import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FormsLayer from "../components/FormsLayer";

const FormsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Form Library">
        {/* FormsLayer */}
        <FormsLayer />
      </MasterLayout>
    </>
  );
};

export default FormsPage;
